import { Component } from '@angular/core';

@Component({
  selector: 'app-issue-seller-contract-brief-report',
  templateUrl: './issue-seller-contract-brief-report.component.html',
  styleUrl: './issue-seller-contract-brief-report.component.scss'
})
export class IssueSellerContractBriefReportComponent {

}
